import { baseApi } from './baseApi';

const toQuery = (filter = {}) => {
  const p = new URLSearchParams();
  Object.entries(filter).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : '';
};

export const sessionsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listSessions: build.query({
      query: (filter) => `/sessions${toQuery(filter)}`,
      transformResponse: (resp) => resp.data,
      providesTags: (result) => [
        { type: 'Session', id: 'LIST' },
        ...(result?.items?.map((s) => ({ type: 'Session', id: s.id })) ?? []),
      ],
    }),
    todaySessions: build.query({
      query: (therapistUserId) => `/sessions/today${therapistUserId ? `?therapistUserId=${therapistUserId}` : ''}`,
      transformResponse: (resp) => resp.data,
      providesTags: [{ type: 'Session', id: 'TODAY' }],
    }),
    createSession: build.mutation({
      query: (body) => ({ url: '/sessions', method: 'POST', body }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: [{ type: 'Session', id: 'LIST' }, { type: 'Session', id: 'TODAY' }],
    }),
    completeSession: build.mutation({
      query: ({ id, ...body }) => ({ url: `/sessions/${id}/complete`, method: 'PATCH', body }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Session', id },
        { type: 'Session', id: 'LIST' },
        { type: 'Session', id: 'TODAY' },
        'Dashboard',
      ],
    }),
    cancelSession: build.mutation({
      query: ({ id, reason }) => ({ url: `/sessions/${id}/cancel`, method: 'PATCH', body: { reason } }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: (_r, _e, { id }) => [{ type: 'Session', id }, { type: 'Session', id: 'LIST' }],
    }),
    updateSession: build.mutation({
      query: ({ id, ...body }) => ({ url: `/sessions/${id}`, method: 'PUT', body }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Session', id },
        { type: 'Session', id: 'LIST' },
        { type: 'Session', id: 'TODAY' },
        { type: 'Patient', id: 'LIST' },
        'Dashboard',
      ],
    }),
  }),
});

export const {
  useListSessionsQuery, useLazyListSessionsQuery,
  useTodaySessionsQuery,
  useCreateSessionMutation,
  useCompleteSessionMutation,
  useCancelSessionMutation,
  useUpdateSessionMutation,
} = sessionsApi;
